// CashLobby.jsx
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearCashLobbyFilters } from "@/Poker/redux/slices/lobbySlice";
import styles from "./A23CashLobby.module.css";
// import RoomTile from "../../../components/RoomTile/RoomTile";
import { RoomTile } from '@themed-components';
// import RecommendedTile from "@/src/components/RecommendedTile/RecommendedTile";
import { RecommendedTile } from '@themed-components';
// import GameTypeHeader from "../../../components/GameTypeHeader/GameTypeHeader";
import { GameTypeHeader } from '@themed-components';
import { HEADER_GAME_TYPES } from "@/Poker/data/Constants";
import useHomeLobby from "../../../hooks/data/useHomeLobby";
import { useCashLobbyFilterSortConfig, useInitialSortFilterComplete, useReceivedLobbyData } from "../../../hooks/data/useLobby";
// import LobbyBuyIn from "@/src/components/BuyIn/LobbyBuyIn";
import { LobbyBuyIn } from '@themed-components';
// import TabBar from "@/src/components/TabBar/TabBar";
import { TabBar } from '@themed-components';
import ActiveGamesButton from "@/src/components/ActiveGamesButton/ActiveGamesButton";
import { OMAHA, OMAHA5, OMAHA6, TEXAS_HOLDEM } from "@/Poker/data/Constants";
import { setCashLobbyActiveTab } from "@/Poker/redux/slices/lobbySlice";
import useGameTypeRooms from "@/src/hooks/data/useGameTypeRooms";
import useLobbySocket from "@/src/hooks/utils/useLobbySocket";
import TileSkeleton from "@/src/components/TileSkeleton/TileSkeleton";
import useHomePageData from "@/src/hooks/utils/useHomePageData";

const TABS = [
  {
    name: "NLH",
    gameType: TEXAS_HOLDEM,
  },
  {
    name: "PLO 4",
    gameType: OMAHA,
  },
  {
    name: "PLO 5",
    gameType: OMAHA5,
  },
  {
    name: "PLO 6",
    gameType: OMAHA6,
  },
];

const A23CashLobby = () => {
  const dispatch = useDispatch();
  const { recommendedGames } = useHomeLobby();
  const cashLobbyFilterSortConfig = useCashLobbyFilterSortConfig();
  const initialSortFilterComplete = useInitialSortFilterComplete();
  const receivedLobbyData = useReceivedLobbyData();
  const [isLoading, setIsLoading] = useState(true);
  const activeTab = useSelector((state) => state.lobby.cashLobbyActiveTab);
  const roomsList = useGameTypeRooms();
  const { saveCashLobbySortPreferences } = useLobbySocket();
  useHomePageData();

  const onGameTabChange = (tab) => {
    dispatch(setCashLobbyActiveTab({ tab }));
  };

  const handleClearFilters = () => {
    dispatch(clearCashLobbyFilters());
    saveCashLobbySortPreferences();
  };

  useEffect(() => {
    if (initialSortFilterComplete) {
      setIsLoading(false);
    }
  }, [initialSortFilterComplete]);

  return (
    <div className={styles.container}>
      <GameTypeHeader type={HEADER_GAME_TYPES.CASH} />

      <div className={styles.scrollArea}>
        {recommendedGames.length > 0 && receivedLobbyData ? (
          <div className={styles.recommendedGames}>
            {recommendedGames.map((gameDefId, idx) => {
              return <RecommendedTile
                index={idx}
                key={"RecommendedTile-CashLobby-idx-" + idx}
                gameDefId={gameDefId}
              />
            })}
          </div>
        ) : null}

        <div className={styles.gamesListContainer}>
          <TabBar
            tabs={TABS}
            activeTab={activeTab}
            onTabChange={onGameTabChange}
          />

          <div className={styles.roomList}>
            {isLoading ? (
              <div className={styles.loadingState}>
                <div className={styles.loadingContent}>
                  {
                    Array.from({ length: 3 }).map((_, index) => (
                      <TileSkeleton type="room" key={index} />
                    ))
                  }
                </div>
              </div>
            ) : roomsList.length > 0 ? (
              roomsList.map((roomId, idx) => (
                <RoomTile key={idx} roomId={roomId} />
              ))
            ) : (
              <div className={styles.emptyState}>
                <div className={styles.emptyStateContent}>
                  <h3 className={styles.emptyStateTitle}>
                    Oops! You cannot go all-in
                  </h3>
                  <p className={styles.emptyStateMessage}>
                    There are no cash games that match your suit.
                  </p>
                  {cashLobbyFilterSortConfig.hasActiveFilters && (
                    <>
                      <button className={styles.clearFiltersButton} onClick={handleClearFilters}>
                        Clear filters
                      </button>
                      <LobbyBuyIn />
                    </>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <ActiveGamesButton />
    </div>
  );
};

export default A23CashLobby;
